// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_relative__1yW5F {
  position: relative; }

.styles_absolute__R5Niu {
  position: absolute; }

.styles_maxWidth__oPBp2 {
  width: -webkit-fill-available; }

.styles_flex__q4B8x {
  display: flex; }
  .styles_flex__q4B8x.styles_reverse__bXBTO {
    flex-direction: row-reverse; }

.styles_column__DLU0n {
  flex-direction: column; }
  .styles_column__DLU0n.styles_reverse__bXBTO {
    flex-direction: column-reverse; }

.styles_center__mRAIm {
  justify-content: center;
  align-items: center; }

.styles_spaceBetween__s0osk {
  justify-content: space-between; }

.styles_spaceAround__84d6r {
  justify-content: space-around; }

.styles_span__Aqbkk {
  flex: 1 1;
  height: -webkit-fill-available;
  width: -webkit-fill-available; }

.styles_fitContent__jKcgz {
  width: fit-content;
  height: fit-content; }

.styles_flexEnd__5Rxry {
  justify-content: flex-end; }

.styles_flexStart__qXQuQ {
  justify-content: flex-start; }

.styles_alignCenter__boWQd {
  align-items: center; }

.styles_absolute__R5Niu {
  position: absolute; }

.styles_bottom__4r37z {
  bottom: 0; }

.styles_mt1__7Z9pv {
  margin-top: 1rem; }

.styles_mt3__UQ02n {
  margin-top: 3rem; }

.styles_pb3__jsGQ0 {
  padding-bottom: 3rem; }

.styles_b1grey__\\+ogle {
  border: 1px solid #808080b8; }

.styles_br1__xE1Xf {
  border-radius: 1rem; }

.styles_pHalf__WvnpO {
  padding: 0.5rem; }

.styles_p1__fnucC {
  padding: 1rem; }

.styles_p3__9QDkE {
  padding: 3rem; }

.styles_pr3__VdmwM {
  padding-right: 3rem; }

.styles_scrollY__lBWza {
  overflow-y: scroll; }

.styles_bt1grey__xrqhQ {
  border-top: 1px solid grey; }

.styles_bl1__w41jK {
  border-left: 1; }

.styles_alignEnd__RdEle {
  align-items: flex-end; }

.styles_maxHeight__\\+ovxU {
  height: -webkit-fill-available; }

.styles_maxWidth__oPBp2 {
  width: -webkit-fill-available; }

.styles_fso72__ynDDr {
  font-size: 0.72rem; }

.styles_fixed__QyaEI {
  position: fixed; }

.styles_shadow__dt-57 {
  box-shadow: 1rem 1rem 2rem #8080805c; }

.styles_justifyCenter__FZMmR {
  justify-content: center; }

.styles_lightShadow__slgof {
  box-shadow: 0.5rem 0.5rem 1rem #8080801a; }

.styles_mb1__q0aT- {
  margin-bottom: 1rem; }

.styles_mb3__Gaijd {
  margin-bottom: 3rem; }

.styles_fs75__VUnh7 {
  font-size: 0.75rem; }

.styles_fs90__Ls3m3 {
  font-size: 0.9rem; }

.styles_fs150__2rn2n {
  font-size: 1.5rem; }

.styles_fs120__5HGsx {
  font-size: 1.2rem; }

.styles_italic__ocn-J {
  font-style: italic; }

.styles_bold__tofEc {
  font-weight: 700; }

.styles_borderless__6KTYu {
  border: none !important;
  border-color: transparent;
  border-width: 0rem; }

.styles_ml1__PB2hN {
  margin-left: 1rem; }

.styles_ml3__-1zbX {
  margin-left: 3rem; }

.styles_grey__Gz2lr {
  color: #808080; }

.styles_grey50__czUa- {
  color: #80808080; }

.styles_grey90__KTEYd {
  color: #808080e6; }

.styles_underline__4R1a2 {
  text-decoration: underline; }

h2.styles_center__mRAIm {
  text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/hooks/ui-kit/useClassNames/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB,EAAA;;AAGtB;EACI,6BAA6B,EAAA;;AAGjC;EACI,aAAa,EAAA;EADjB;IAGQ,2BAA2B,EAAA;;AAGnC;EACI,sBAAsB,EAAA;EAD1B;IAGQ,8BAA8B,EAAA;;AAItC;EACI,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,8BAA8B,EAAA;;AAGlC;EACI,6BAA6B,EAAA;;AAGjC;EACI,SAAS;EACT,8BAA8B;EAC9B,6BAA6B,EAAA;;AAGjC;EACI,kBAAkB;EAClB,mBAAmB,EAAA;;AAGvB;EACI,yBAAyB,EAAA;;AAG7B;EACI,2BAA2B,EAAA;;AAG/B;EACI,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB,EAAA;;AAGtB;EACI,SAAS,EAAA;;AAGb;EACI,gBACJ,EAAA;;AAEA;EACI,gBAAgB,EAAA;;AAGpB;EACI,oBAAoB,EAAA;;AAGxB;EACI,2BClEc,EAAA;;ADqElB;EACI,mBAAmB,EAAA;;AAGvB;EACI,eAAe,EAAA;;AAGnB;EACI,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;AAGjB;EACI,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB,EAAA;;AAGtB;EACI,0BAA0B,EAAA;;AAG9B;EACI,cAAc,EAAA;;AAGlB;EACI,qBAAqB,EAAA;;AAGzB;EACI,8BAA8B,EAAA;;AAGlC;EACI,6BAA6B,EAAA;;AAGjC;EACI,kBAAkB,EAAA;;AAGtB;EACI,eAAe,EAAA;;AAGnB;EACI,oCC7Hc,EAAA;;ADgIlB;EACI,uBAAuB,EAAA;;AAG3B;EACI,wCCvIc,EAAA;;AD0IlB;EACI,mBAAmB,EAAA;;AAGvB;EACI,mBAAmB,EAAA;;AAGvB;EACI,kBAAkB,EAAA;;AAGtB;EACI,iBAAiB,EAAA;;AAGrB;EACI,iBAAiB,EAAA;;AAGrB;EACI,iBAAiB,EAAA;;AAGrB;EACI,kBAAkB,EAAA;;AAItB;EACI,gBAAgB,EAAA;;AAGpB;EACI,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB,EAAA;;AAGtB;EACI,iBAAiB,EAAA;;AAGrB;EACI,iBAAiB,EAAA;;AAGrB;EACI,cCnLU,EAAA;;ADsLd;EACI,gBC3Lc,EAAA;;AD8LlB;EACI,gBC5Lc,EAAA;;AD+LlB;EACI,0BAA0B,EAAA;;AAI9B;EACI,kBAAkB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.relative {\n    position: relative;\n}\n.absolute {\n    position: absolute;\n}\n\n.maxWidth {\n    width: -webkit-fill-available;\n}\n\n.flex {\n    display: flex;\n    &.reverse {\n        flex-direction: row-reverse;\n    }\n}\n.column {\n    flex-direction: column;\n    &.reverse {\n        flex-direction: column-reverse;\n    }\n}\n\n.center {\n    justify-content: center;\n    align-items: center;\n}\n\n.spaceBetween {\n    justify-content: space-between;\n}\n\n.spaceAround {\n    justify-content: space-around;\n}\n\n.span {\n    flex: 1 1;\n    height: -webkit-fill-available;\n    width: -webkit-fill-available;\n}\n\n.fitContent {\n    width: fit-content;\n    height: fit-content;\n}\n\n.flexEnd {\n    justify-content: flex-end;\n}\n\n.flexStart {\n    justify-content: flex-start;\n}\n\n.alignCenter {\n    align-items: center;\n}\n\n.absolute {\n    position: absolute;\n}\n\n.bottom {\n    bottom: 0;\n}\n\n.mt1 {\n    margin-top: 1rem\n}\n\n.mt3 {\n    margin-top: 3rem;\n}\n\n.pb3 {\n    padding-bottom: 3rem;\n}\n\n.b1grey {\n    border: 1px solid $grey72;\n}\n\n.br1 {\n    border-radius: 1rem;\n}\n\n.pHalf {\n    padding: 0.5rem;\n}\n\n.p1 {\n    padding: 1rem;\n}\n\n.p3 {\n    padding: 3rem;\n}\n\n.pr3 {\n    padding-right: 3rem;\n}\n\n.scrollY {\n    overflow-y: scroll;\n}\n\n.bt1grey {\n    border-top: 1px solid grey;\n}\n\n.bl1 {\n    border-left: 1;\n}\n\n.alignEnd {\n    align-items: flex-end;\n}\n\n.maxHeight {\n    height: -webkit-fill-available;\n}\n\n.maxWidth {\n    width: -webkit-fill-available;\n}\n\n.fso72 {\n    font-size: 0.72rem;\n}\n\n.fixed {\n    position: fixed;\n}\n\n.shadow {\n    box-shadow: 1rem 1rem 2rem $grey36;\n}\n\n.justifyCenter {\n    justify-content: center;\n}\n\n.lightShadow {\n    box-shadow: 0.5rem 0.5rem 1rem $grey10;\n}\n\n.mb1 {\n    margin-bottom: 1rem;\n}\n\n.mb3 {\n    margin-bottom: 3rem;\n}\n\n.fs75 {\n    font-size: 0.75rem;\n}\n\n.fs90 {\n    font-size: 0.9rem;\n}\n\n.fs150 {\n    font-size: 1.5rem;\n}\n\n.fs120 {\n    font-size: 1.2rem;\n}\n\n.italic {\n    font-style: italic;\n\n}\n\n.bold {\n    font-weight: 700;\n}\n\n.borderless {\n    border: none !important;\n    border-color: transparent;\n    border-width: 0rem;\n}\n\n.ml1 {\n    margin-left: 1rem;\n}\n\n.ml3 {\n    margin-left: 3rem;\n}\n\n.grey {\n    color: $grey;\n}\n\n.grey50 {\n    color: $grey50;\n}\n\n.grey90 {\n    color: $grey90;\n}\n\n.underline {\n    text-decoration: underline;\n}\n\n\nh2.center {\n    text-align: center;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"relative": `styles_relative__1yW5F`,
	"absolute": `styles_absolute__R5Niu`,
	"maxWidth": `styles_maxWidth__oPBp2`,
	"flex": `styles_flex__q4B8x`,
	"reverse": `styles_reverse__bXBTO`,
	"column": `styles_column__DLU0n`,
	"center": `styles_center__mRAIm`,
	"spaceBetween": `styles_spaceBetween__s0osk`,
	"spaceAround": `styles_spaceAround__84d6r`,
	"span": `styles_span__Aqbkk`,
	"fitContent": `styles_fitContent__jKcgz`,
	"flexEnd": `styles_flexEnd__5Rxry`,
	"flexStart": `styles_flexStart__qXQuQ`,
	"alignCenter": `styles_alignCenter__boWQd`,
	"bottom": `styles_bottom__4r37z`,
	"mt1": `styles_mt1__7Z9pv`,
	"mt3": `styles_mt3__UQ02n`,
	"pb3": `styles_pb3__jsGQ0`,
	"b1grey": `styles_b1grey__+ogle`,
	"br1": `styles_br1__xE1Xf`,
	"pHalf": `styles_pHalf__WvnpO`,
	"p1": `styles_p1__fnucC`,
	"p3": `styles_p3__9QDkE`,
	"pr3": `styles_pr3__VdmwM`,
	"scrollY": `styles_scrollY__lBWza`,
	"bt1grey": `styles_bt1grey__xrqhQ`,
	"bl1": `styles_bl1__w41jK`,
	"alignEnd": `styles_alignEnd__RdEle`,
	"maxHeight": `styles_maxHeight__+ovxU`,
	"fso72": `styles_fso72__ynDDr`,
	"fixed": `styles_fixed__QyaEI`,
	"shadow": `styles_shadow__dt-57`,
	"justifyCenter": `styles_justifyCenter__FZMmR`,
	"lightShadow": `styles_lightShadow__slgof`,
	"mb1": `styles_mb1__q0aT-`,
	"mb3": `styles_mb3__Gaijd`,
	"fs75": `styles_fs75__VUnh7`,
	"fs90": `styles_fs90__Ls3m3`,
	"fs150": `styles_fs150__2rn2n`,
	"fs120": `styles_fs120__5HGsx`,
	"italic": `styles_italic__ocn-J`,
	"bold": `styles_bold__tofEc`,
	"borderless": `styles_borderless__6KTYu`,
	"ml1": `styles_ml1__PB2hN`,
	"ml3": `styles_ml3__-1zbX`,
	"grey": `styles_grey__Gz2lr`,
	"grey50": `styles_grey50__czUa-`,
	"grey90": `styles_grey90__KTEYd`,
	"underline": `styles_underline__4R1a2`
};
export default ___CSS_LOADER_EXPORT___;
